'use client';

import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="bg-cyber-darker border-t border-gray-800 py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <p className="text-sm text-gray-400">
            Made with{' '}
            <span className="animate-pulse text-matrix-400 transition-transform hover:scale-110 hover:text-matrix-300">
              ❤️
            </span>{' '}
            from India
          </p>

          <div className="flex items-center gap-6">
            <Link
              href="/privacy-policy"
              className="text-sm text-gray-400 transition-colors hover:text-white"
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms-of-service"
              className="text-sm text-gray-400 transition-colors hover:text-white"
            >
              Terms of Service
            </Link>
            <p className="text-sm text-gray-500">
              &copy; {new Date().getFullYear()} ThousandX Ventures LLP
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
